module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "top": "5vh",
      "visible": _vm.isVisible,
      "width": '25%',
      "custom-class": 'panel-settings-dialog',
      "title": 'Panel configuration'
    },
    on: {
      "update:visible": function($event) {
        _vm.isVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('div', {
    staticClass: "ibox-content ibox-heading"
  }, [_vm._v("\n      Settings for interactions that show up in the panel.\n    ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Name of the panel",
      "placement": "bottom"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Panel name"
    }
  }, [_c('el-input', {
    attrs: {
      "minlength": 1,
      "maxlength": 40,
      "disabled": _vm.panelType === 'onair'
    },
    model: {
      value: (_vm.settings.name),
      callback: function($$v) {
        _vm.$set(_vm.settings, "name", $$v)
      },
      expression: "settings.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Set the panel layout size",
      "placement": "bottom"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Column Layout"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settings.columns),
      callback: function($$v) {
        _vm.$set(_vm.settings, "columns", $$v)
      },
      expression: "settings.columns"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("1 Column")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("2 Column")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("3 Column")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Preload media"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Preload audio and video",
      "placement": "bottom"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settings.mediaPreload),
      callback: function($$v) {
        _vm.$set(_vm.settings, "mediaPreload", $$v)
      },
      expression: "settings.mediaPreload"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "auto"
    }
  }, [_vm._v("On")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("Off")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelType !== 'activity'),
      expression: "panelType !== 'activity'"
    }],
    attrs: {
      "label": "Panel Locker"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Panel exit locker",
      "placement": "bottom"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.settings.panelLock),
      callback: function($$v) {
        _vm.$set(_vm.settings, "panelLock", $$v)
      },
      expression: "settings.panelLock"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "none"
    }
  }, [_vm._v("On")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "auto"
    }
  }, [_vm._v("Off")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Panel Color"
    }
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Set a unique colour for your panel",
      "placement": "bottom"
    }
  }, [_c('el-color-picker', {
    model: {
      value: (_vm.settings.colour),
      callback: function($$v) {
        _vm.$set(_vm.settings, "colour", $$v)
      },
      expression: "settings.colour"
    }
  })], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOnAirOrActivity),
      expression: "!isOnAirOrActivity"
    }],
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Select campaigns you want to get interactions from",
      "placement": "bottom"
    }
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n          Campaigns\n          "), _c('el-tooltip', {
    attrs: {
      "content": "Select All",
      "placement": "right"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.isAllCampaignsChecked),
      callback: function($$v) {
        _vm.isAllCampaignsChecked = $$v
      },
      expression: "isAllCampaignsChecked"
    }
  })], 1)], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "size": "large",
      "placeholder": "Select...",
      "filterable": "",
      "collapse-tags": "",
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.settings.campaign_ids),
      callback: function($$v) {
        _vm.$set(_vm.settings, "campaign_ids", $$v)
      },
      expression: "settings.campaign_ids"
    }
  }, _vm._l((_vm.campaigns), function(campaign) {
    return _c('el-option', {
      key: campaign.id,
      attrs: {
        "label": campaign.title,
        "value": campaign.id
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isOnAirOrActivity),
      expression: "!isOnAirOrActivity"
    }],
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Select channels you want to get interactions from",
      "placement": "bottom"
    }
  }, [_c('el-form-item', [_c('span', {
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("\n          Channels\n          "), _c('el-tooltip', {
    attrs: {
      "content": "Select All",
      "placement": "right"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.isAllChannelsChecked),
      callback: function($$v) {
        _vm.isAllChannelsChecked = $$v
      },
      expression: "isAllChannelsChecked"
    }
  })], 1)], 1), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "large",
      "placeholder": "Select...",
      "multiple": "",
      "filterable": "",
      "collapse-tags": "",
      "disabled": _vm.isOnAirOrActivity
    },
    model: {
      value: (_vm.settings.channel_ids),
      callback: function($$v) {
        _vm.$set(_vm.settings, "channel_ids", $$v)
      },
      expression: "settings.channel_ids"
    }
  }, _vm._l((_vm.activeChannels), function(channel) {
    return _c('el-option', {
      key: channel.id,
      attrs: {
        "label": channel.title,
        "value": channel.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(channel.title))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "0.7em",
        "margin-right": "1.6em"
      }
    }, [_vm._v(_vm._s(channel.channel_type_title))])])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.updatingSettings
    },
    on: {
      "click": _vm.saveSettings
    }
  }, [_vm._v("Save Panel Settings")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98f365c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/MessagePanelSettings.vue
// module id = 3372
// module chunks = 3